import { useNavigate } from "react-router-dom";

/**
 * @typedef {import("../../../../../hooks/teacher/classroom/useGetClassroomById").StudentType} StudentType
 */

/**
 * @typedef {Object} ClassroomTableRowProps
 * @property {StudentType} student - Student object
 */

/**
 * ClassroomTableRow component displays a single student row
 * @param {ClassroomTableRowProps} props
 * @param {"school-admin" | "teacher"} props.type - Type of user  
 * @returns {JSX.Element}
 */
const ClassroomTableRow = ({ student, type }) => {
  const navigate = useNavigate();

  return (
    <tr
      onClick={() => {
        if (type === "school-admin") {
          navigate(`/school-admin/school/report/students/${student.id}`);
        } else {
          navigate(`/teacher/student/${student.id}`);
        }
      }}
      style={{ cursor: "pointer" }}
    >
      <td className="custom-id">{student?.username || "-"}</td>
      <td>{student?.name || "-"}</td>
      <td>{student?.email || "-"}</td>
      <td>
        <button className="custom-detail-btn">
          <i className="bi bi-three-dots-vertical" />
        </button>
      </td>
    </tr>
  );
};

export default ClassroomTableRow;
